import { Nav, NavItem, NavLink } from "reactstrap";
import { Contact, Href, Inbox, Home } from "../../Utils/Constants";
import { getLabel } from "../../sharedFunctions/CommonLable";

type propsType = {
    basicTab: string;
    setBasicTab: (data: string) => void;
    employeeIdProp?: number;
}

export default function BorderNav({ basicTab, setBasicTab, employeeIdProp }: propsType) {
    // console.log(employeeIdProp, 'employeeId in navtab');

    return (
        <Nav tabs className='border-tab nav-info mb-0 profile-nav-tabs'>
            <NavItem>
                <NavLink href="#" className={`nav-border txt-info tab-info ${basicTab === '1' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('1'); }}><i className="icofont icofont-ui-home" />{'User'}</NavLink>
            </NavItem>
            {employeeIdProp && <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '2' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('2'); }}><i className="icofont icofont-ui-message" />{'Attendance'}</NavLink>
            </NavItem>}
            {employeeIdProp && <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '3' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('3'); }}><i className="icofont icofont-man-in-glasses" />{'Reporting'}</NavLink>
            </NavItem>}
            {employeeIdProp && <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '4' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('4'); }}><i className="icofont icofont-ui-message" />{getLabel('Inputs')}</NavLink>
            </NavItem>}
            {employeeIdProp && <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '5' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('5'); }}><i className="icofont icofont-ui-message" />{'Leaves'}</NavLink>
            </NavItem>}
            {employeeIdProp && <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '6' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('6'); }}><i className="icofont icofont-bill-alt" />{'Expense'}</NavLink>
            </NavItem>}
            {employeeIdProp && <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '7' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('7'); }}><i className="icofont icofont-ui-calendar" />{getLabel('MTP')}</NavLink>
            </NavItem>}
            {employeeIdProp && <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '8' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('8'); }}><i className="icofont icofont-sun-alt" />{'Holidays'}</NavLink>
            </NavItem>}
            {employeeIdProp && <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '9' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('9'); }}><i className="icofont icofont-bullhorn" />{'Brand Campaign'}</NavLink>
            </NavItem>}
        </Nav>
    )
}
